import { useEffect, useState } from 'react';

import { Translate, useTranslate } from '@spazious/dollhouse-i18n';
import { useEventCallback } from '@spazious/react-hooks';

import { DollhouseMessage, MainViewMessage } from '../../core/EventManager.js';
import { ConfirmDialog } from '../ConfirmDialog/index.js';
import { useEvents } from '../EventManager/index.js';

export const RestrictedAreaDialog: React.FC = () => {
  const events = useEvents();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const translate = useTranslate();

  useEffect(() => {
    const cb = (message: DollhouseMessage) => {
      if (message === DollhouseMessage.RestrictedAreaEntered) {
        setIsDialogOpen(true);
      }
    };
    events.on('dollhouseMessage', cb);
    return () => {
      events.off('dollhouseMessage', cb);
    };
  }, [events]);

  const handleRestrictedAreaConfirmClose = useEventCallback(() => {
    events.emit('mainViewMessage', MainViewMessage.RestrictedAreaActionRevert);
    setIsDialogOpen(false);
  });

  const doIgnoreRestrictedArea = useEventCallback(() => {
    events.emit('mainViewMessage', MainViewMessage.RestrictedAreaActionIgnore);
    setIsDialogOpen(false);
  });

  return (
    <ConfirmDialog
      fullWidth
      confirmButtonLabel={translate('Ignore')}
      content={<Translate>Do you want to ignore restricted area?</Translate>}
      maxWidth="600px"
      open={isDialogOpen}
      setting="checkRestrictedAreas"
      title={<Translate>Oops! 🚫 No furniture allowed here.</Translate>}
      onClose={handleRestrictedAreaConfirmClose}
      onConfirm={doIgnoreRestrictedArea}
    />
  );
};
